<template lang="pug">
v-dialog(:value="!!value" @input="close()" fullscreen)
  v-card(v-if="edit")
    v-card-title.primary
      span.title.white--text Druckvorlage {{isNew ? 'Neu' : 'Bearbeiten'}}
      v-spacer
      v-btn(dark icon @click="close()"): v-icon close
    v-container(grid-list-xl)
      v-card.mb-3.mx-a(max-width="700")
        v-card-text: v-layout(wrap)
          v-flex(xs12 md6): v-text-field(label="Name" v-model="edit.name" :error-messages="gqlErrorsFor('druckVorlageMutate', 'name')")
          v-flex(xs12 md6): v-text-field(label="Slug" v-model="edit.slug" :error-messages="gqlErrorsFor('druckVorlageMutate', 'slug')")
          v-flex(xs12 md6): v-select(label="Art" v-model="edit.art" :items="[{ text: 'PV', value: 'pv' }, { text: 'Visitenkarte', value: 'vika' }]" :error-messages="gqlErrorsFor('druckVorlageMutate', 'art')")
          v-flex(xs12): v-alert(:value="differentPageSizes" type="error") Alle Seiten müssen die selbe grösse haben
        v-card-actions
          v-btn(@click="save" :loading="loading > 0") <v-icon>save</v-icon> Speichern
          template(v-if="!isNew")
            v-btn(@click="addPage") <v-icon>add</v-icon> Seite Hinzufügen
            v-spacer
            v-btn(@click="destroy" :loading="loadingDestroy > 0" v-if="!isNew") <v-icon>delete</v-icon> Löschen

      v-card.mb-3.mx-a(max-width="700" v-if="!isNew")
        v-card-text: v-layout(wrap)
          v-flex(xs12 sm4): v-text-field(label="PV ID" v-model="pvId" hide-details)
          v-flex(xs12 sm8)
            v-btn-toggle(v-model="preview")
              v-btn( active-class="primary--text" :disabled="!patientenverfuegung"): v-icon visibility
            v-btn-toggle(v-model="border")
              v-btn(active-class="primary--text"): v-icon format_align_justify
            v-btn-toggle(v-model="bg" mandatory)
              v-btn(flat class="grey lighten-4" active-class="primary--text"): v-icon view_agenda
              v-btn(flat class="grey lighten-1" active-class="primary--text"): v-icon view_agenda
              v-btn(flat class="grey" active-class="primary--text"): v-icon view_agenda
              v-btn(flat class="grey darken-3" active-class="primary--text"): v-icon view_agenda
            v-btn(@click="settings = value") <v-icon>settings</v-icon> Einstellungen
          v-flex(xs12 sm4): v-checkbox(label="Bezeugung" v-model="bezeugung")
          v-flex(xs12 sm4): v-text-field(label="Ausdrucke" v-model="ausdrucke" hide-details type="number")
          v-flex(xs12 sm4)
            v-btn(@click="print($event)" :loading="printing" :disabled="preview !== 0 || printingPDF" block) Drucken
            v-btn(@click="print($event, true)" :loading="printingPDF" :disabled="preview !== 0 || printing" block) PDF
          v-flex(xs12): v-alert(:value="!!printError" type="error") {{printError}}

    template(v-if="!isNew")
      extra-druck-vorlagen-render(ref="render" :bezeugung="bezeugung" :value="edit" :bg="bg", :border="border === 0" :anzahl="+ausdrucke" :item="preview === 0 ? patientenverfuegung : null" :url2pdfHost="url2pdfHost")
      extra-druck-vorlagen-settings(v-model="settings")
    .pb-3

</template>

<script>
import gql from 'graphql-tag'
import GraphqlErrorObject from '../../mixins/graphql-error-object.js'
import ExtraDruckVorlagenRender from "./extra-druck-vorlagen-render.vue"
import ExtraDruckVorlagenSettings from "./extra-druck-vorlagen-settings.vue"
import { uniq } from 'lodash'

export default {
  props: {
    value: String,
    url2pdfHost: String,
  },
  mixins: [GraphqlErrorObject],
  components: {
    ExtraDruckVorlagenRender,
    ExtraDruckVorlagenSettings,
  },
  data() {
    return {
      edit: null,
      printError: null,
      pvId: null,
      preview: null,
      bg: 3,
      bezeugung: false,
      ausdrucke: 2,
      printing: false,
      printingPDF: false,
      settings: null,
      border: 0,
      patientenverfuegungen: [],
      loading: 0,
      loadingDestroy: 0,
    }
  },
  apollo: {
    currentUser: {
      query: gql`query ExtradruckVorlagenEditVue {
        currentUser {
          id
          vorname
          nachname
        }
      }`
    },
    druckVorlagen: {
      query: gql`query ExtradruckVorlagenVue($id: ID) {
        druckVorlagen(where: { id: $id}) {
          id
          name
          slug
          art
          pages {
            backgroundName
            backgroundUrl
            format
            height
            width
            texts {
              x
              y
              width
              height
              lineHeight
              size
              type
              text
              template
              options
            }
          }
        }
      }`,
      fetchPolocy: 'network-only',
      variables() {
        return {
          id: this.value
        }
      },
      skip() {
        return !this.value || this.value === 'neu'
      }
    },
    patientenverfuegungen: {
      query: gql`query ExtradruckVorlagenVuePV($id: ID) {
        patientenverfuegungen(where: { id: $id }) {
          id
          status
          vorname
          nachname
          dringlichkeit
          betrag
          data
        }
      }`,
      variables() {
        return {
          id: this.pvId
        }
      },
      skip() {
        return !this.pvId
      }
    }
  },
  watch: {
    value() {
      this.fillEdit()
    },
    druckVorlagen() {
      this.fillEdit()
    }
  },
  computed: {
    isNew() {
      return this.value === 'neu'
    },
    differentPageSizes() {
      if (this.edit) {
        return uniq(this.edit.pages.map(p => `${p.width}x${p.height}`)).length > 1
      } else {
        return false
      }
    },
    patientenverfuegung() {
      return this.pvId && this.patientenverfuegungen[0]
    }
  },
  methods: {
    fillEdit() {
      const d = this.isNew ? {} : this.druckVorlagen && this.druckVorlagen[0] || {}
      const edit = {}
      edit.id = d.id || null
      edit.name = `${d.name || ''}`
      edit.slug = `${d.slug || ''}`
      edit.art = `${d.art || ''}`
      edit.pages = d.pages && d.pages.map(p => ({
        ...p,
        __typename: undefined,
        texts: p.texts.map(t => ({
          ...t,
          __typename: undefined
        }))
      })) || []
      this.edit = edit
    },
    close(id) {
      this.gqlClearAllErrors()
      this.edit = null
      this.$emit('reload')
      this.$emit('input', id || null)
    },
    destroy() {
      if (!this.isNew && window.confirm("wirklich löschen?")) {
        this.loadingDestroy++
        this.gqlClearAllErrors()
        this.$apollo.mutate({
          mutation: gql`mutation ExtraDruckVorlagenEditVueDestroy($id: ID!) {
            druckVorlageDestroy(id: $id) {
              success
            }
          }`,
          variables: { id: this.value },
        }).then((data) => {
          this.loadingDestroy--
          this.close()
        }).catch((error) => {
          this.gqlAddErrors(error)
          this.loadingDestroy--
        })
      }
    },
    save() {
      this.loading++
      this.gqlClearAllErrors()
      let mutation;
      if (this.isNew) {
        mutation = this.$apollo.mutate({
          mutation: gql`mutation ExtraDruckVorlagenEditVueCreate(
            $name: String
            $slug: String
            $art: String
          ) {
            druckVorlageMutate: druckVorlageCreate(
              name: $name
              slug: $slug
              art: $art
            ) {
              id
              name
              slug
              art
              pages {
                backgroundName
                backgroundUrl
                format
                height
                width
                texts {
                  x
                  y
                  width
                  height
                  size
                  lineHeight
                  type
                  text
                  template
                  options
                }
              }
            }
          }`,
          variables: this.edit,
        })
      } else {
        mutation = this.$apollo.mutate({
          mutation: gql`mutation ExtraDruckVorlagenEditVueUpdate(
            $id: ID!
            $name: String
            $slug: String
            $art: String
            $pages: [DruckVorlagePagesInput]
          ) {
            druckVorlageMutate: druckVorlageUpdate(
              id: $id
              name: $name
              slug: $slug
              art: $art
              pages: $pages
            ) {
              id
              name
              slug
              art
              pages {
                backgroundName
                backgroundUrl
                format
                height
                width
                texts {
                  x
                  y
                  width
                  height
                  size
                  lineHeight
                  type
                  text
                  template
                  options
                }
              }
            }
          }`,
          variables: this.edit,
        })
      }
      
      mutation.then((data) => {
        this.loading--
        if (this.isNew) {
          this.close(data.data.druckVorlageMutate.id)
        } else {
          this.close()
        }
      }).catch((error) => {
        this.gqlAddErrors(error)
        this.loading--
      })
    },
    addPage() {
      let size = { format: 'A4', width: 210, height: 296 }
      if (this.edit.pages.length) {
        size = this.edit.pages[0]
      }
      this.edit.pages.push({
        backgroundName: null,
        backgroundUrl: null,
        format: size.format,
        width: size.width,
        height: size.height,
        texts: [],
      })
    },
    async print(event, pdf) {
      const render = this.$refs.render
      this.printError = null
      if (pdf) {
        this.printingPDF = true
      } else {
        this.printing = true
      }
      try {
        window.printed = await render.print({ downloadPdf: pdf, ctrlKey: event.ctrlKey })
      } catch(error) {
        this.printError = "Drucken Fehlgeschlagen"
      } finally {
        if (pdf) {
          this.printingPDF = false
        } else {
          this.printing = false
        }
      }
    },
  },
}
</script>
